/* Reuse the topbar's editable links in the mobile drawer. */
(() => {
  if (window.bpMobileNavigation) return;
  window.bpMobileNavigation = true;
  const sync = () => {
    const target = document.querySelector('.custom-mobile-secondary-links');
    const source = document.querySelector('.custom-topbar__inner');
    if (!target) return;
    target.replaceChildren();
    if (!source) return;
    for (const nav of source.querySelectorAll('nav')) {
      const copy = nav.cloneNode(true);
      copy.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
      target.append(copy);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true});
  else sync();
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(sync));
})();
